import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  addPrefix,
  addSuffix,
  numFormatterWithSuffix,
  numberToCurrencyFormatter,
  roundNumber,
} from './helper';

export interface MedicalAndRxClaimantsDataType {
  currentYearMemberCount: string | number;
  previousYearMemberCount: string | number;
  currentYearCost: string | number;
  previousYearCost: string | number;
  totalCost: string | number;
  totalCostPercentage: string | number;
  memberIds: string[];
}

export interface LabelValueType {
  label: string | number;
  value: string | number;
}

export const formatMedicalAndRxClaimants = (data: any) => {
  const medicalAndRxClaimantsData: MedicalAndRxClaimantsDataType = {
    totalCost: addPrefix('$', numFormatterWithSuffix(data?.totalCost, 2)),
    totalCostPercentage: addSuffix(roundNumber(data?.percentage, 2), '%'),
    currentYearCost: data?.totalCost,
    previousYearCost: data?.prevYearCost,
    currentYearMemberCount: data?.currentYearMemberCount,
    previousYearMemberCount: data?.prevYearMemberCount,
    memberIds: data?.memberIds,
  };

  return medicalAndRxClaimantsData;
};

export const formatCostStratification = (data: any) => {
  const costContributionArray = data.cost_contributional_percentage;
  const memberCumulativeArray = data.member_cumulative_percentage;
  const top1PercentSpenders = data.top_one_percentile;
  const top5PercentSpenders = data.top_five_percentile;
  const top10PercentSpenders = data.top_ten_percentile;

  const costStratificationData: any = [];

  let is1Percent = true;
  let is5percent = true;
  let is10Percent = true;

  memberCumulativeArray?.map((item: any, index: number) => {
    const tempObject: any = {
      label: '',
      value: '',
      showLabel: '0',
    };
    const tempLineObject: any = {
      vLine: '1',
      dashed: '1',
      dashLen: '10',
      dashGap: '5',
      color: patientAccessTheme.palette.primary.main,
      labelHAlign: 'right',
      label: 'Top 1% of spenders',
      showLabel: '0',
      labelPosition: 0,
    };

    if (is1Percent && item > top1PercentSpenders) {
      tempLineObject.label = `Top 1% of spenders <br/> have cost share of ${(
        100 - costContributionArray[index]
      ).toFixed(2)}%`;
      tempLineObject.labelPosition = 0.1;
      costStratificationData.push(tempLineObject);
      is1Percent = false;
    } else if (is5percent && item > top5PercentSpenders) {
      tempLineObject.label = `Top 5% of spenders <br/> have cost share of ${(
        100 - costContributionArray[index]
      ).toFixed(2)}%`;
      tempLineObject.labelPosition = 0.4;
      costStratificationData.push(tempLineObject);
      is5percent = false;
    } else if (is10Percent && item > top10PercentSpenders) {
      tempLineObject.label = `Top 10% of spenders <br/> have cost share of ${(
        100 - costContributionArray[index]
      ).toFixed(2)}%`;
      tempLineObject.labelPosition = 0.7;
      costStratificationData.push(tempLineObject);
      is10Percent = false;
    } else {
      tempObject.label = roundNumber(item, 0).toString() + '%';
      tempObject.showLabel = index % 20 === 0 ? '1' : '0';
      tempObject.value = costContributionArray[index];
      costStratificationData.push(tempObject);
    }
  });

  return costStratificationData;
};

export const formatClaimantsDistData = (data: any) => {
  return data.map((item: any) => {
    return [
      item.category,
      item.costRange,
      item.memberCount,
      numberToCurrencyFormatter(item.totalCost, true),
      numberToCurrencyFormatter(item.planPaid, true),
      numberToCurrencyFormatter(item.memberPaid, true),
    ];
  });
};
